export default "__VITE_ASSET__505c58c4__"